<template>
	<div class="w-full bg-primary-400 phablet:rounded-2xl p-6 phablet:p-12 space-y-8 shadow-widget min-h-full">
		<slot />
	</div>
</template>
